<template></template>
<script>
    import {mapActions} from 'vuex'

    export default {
        name: "HeadUtils",
        props: {
            title: {
                type: String
            }
        },
        methods: {
            ...mapActions(['changeScreenTitle'])
        },
        mounted() {
            document.title = this.title || 'Sistema de Gestão Agrisoy';
            this.changeScreenTitle(document.title);
        }
    }
</script>
